import defaultLayout from "@/layouts/side-nav-outer-toolbar";
import loadView from "../common/loadView";

export default [
  {
    path: "/rejection-reasons/:mode/:id?",
    name: "rejection-reason",
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      layout: defaultLayout,
      navPermission: "Причины отклонения"
    },
    component: loadView("rejection-reasons/rejection-reasons-detail-view"),
  },
  {
    path: "/rejection-reasons",
    name: "rejection-reasons",
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      layout: defaultLayout,
      navPermission: "Причины отклонения"
    },
    component: loadView("rejection-reasons/rejection-reasons-list-view"),
  },
];
